/*
 *   Copyright (c) 2025 LoginID Inc
 *   All rights reserved.

 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at

 *   http://www.apache.org/licenses/LICENSE-2.0

 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

import {
  Button,
  Card,
  Center,
  Container,
  Image,
  Text,
  Title,
} from "@mantine/core";
import { useState } from "react";


export function TestExternal() {
  const [error, setError] = useState("")

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
  }

  function close(){
    window.close()
  }

  function onExternal(type: string) {

  }
  return (
    <Center h="100vh" w="100%" bg="#f8f8f8">
      <Card
        w={{ base: "100%", xs: 540, md: 720 }}
        bg="#f8f8f8"
        mih={420}
        p="sm"
      >
        <Center>
          <Image w={120} src="/assets/wallet-logo.svg" alt="Wallet Logo" />
        </Center>
        <form onSubmit={onSubmit} className="login-form">
          <Container className="container" w="100%">
            <Title ta="left" order={3}>
            </Title>
            <Text ta="left" c="dimmed" mb="lg">
              Test external window.
            </Text>
            {error && (
              <Text c="red.4" lineClamp={64}>
                {error}
              </Text>
            )}


                <Button
                  color="#ca27ca"
                  variant="filled"
                  radius="md"
                  onClick={close}
                >
                  Close 
                </Button>
          </Container>
        </form>
      </Card>
    </Center>
  );
}

